import { __decorate } from "tslib";
import { Module, Mutation, VuexModule } from 'vuex-module-decorators';
let DebugStore = class DebugStore extends VuexModule {
    constructor() {
        super(...arguments);
        this.debugValue = false;
    }
    setDebug(b) {
        this.debugValue = b;
    }
    get debug() {
        return this.debugValue;
    }
};
__decorate([
    Mutation
], DebugStore.prototype, "setDebug", null);
DebugStore = __decorate([
    Module({
        namespaced: true,
    })
], DebugStore);
export default DebugStore;
